import { httpRequest } from "@services/http";
import { Invoice } from "src/shared/models/invoice.model";

export interface GetOrganizationInvoiceParams {
  start?: string;
  end?: string;
}

export class CommandGetOrganizationInvoice {
  async run(organizationId: number, params?: GetOrganizationInvoiceParams): Promise<Invoice> {
    const query = new URLSearchParams();
    if (params?.start) query.set("start", params.start);
    if (params?.end) query.set("end", params.end);

    const qs = query.toString();
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/organizations/${organizationId}/invoice${qs ? `?${qs}` : ""}`;

    const response = await httpRequest<any>(url, { method: "GET", cache: "no-store" });
    return new Invoice(response);
  }
}
